import { useNavigate } from "react-router-dom"

const FeaturedProducts=()=>{

    let navigate =useNavigate()
    return (
        <div class="container-fluid pt-5 pb-3">
        <h2 class="section-title position-relative text-uppercase mx-xl-5 mb-4"><span class="bg-secondary pr-3">Featured Products</span></h2>
        <div class="row px-xl-5">
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" src="img/alfa-alfa-tonic.png" style={{maxHeight:"300px",maxWidth:"200px"}} alt="" />
                    </div>
                    <div class="text-center py-4" onClick={()=>navigate("/home/alfalfa")} >
                        <a class="h6 text-decoration-none text-truncate" >Homeopathic Energy Tonic</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹125.00</h5><h6 class="text-muted ml-2"><del>₹150.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small>(41)</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" src="img/livtsbl.jpg" style={{maxHeight:"300px",maxWidth:"200px"}}  alt="" />
                    </div>
                    <div class="text-center py-4" onClick={()=>navigate("/home/liver")} >
                        <a class="h6 text-decoration-none text-truncate">Homeopathic Liver Tonic</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹110.00</h5><h6 class="text-muted ml-2"><del>₹150.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star-half-alt text-primary mr-1"></small>
                            <small>(92)</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" src="img/stobalsbl.jpg" style={{maxHeight:"300px",maxWidth:"200px"}} alt="" />
                    </div>
                    <div class="text-center py-4" onClick={()=>navigate("/home/cough")} >
                        <a class="h6 text-decoration-none text-truncate" >Homeopathic Cough Syrup</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹55.00</h5><h6 class="text-muted ml-2"><del>₹100.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star-half-alt text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small>(73)</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4" onClick={()=>navigate("/home/jaborandi")}>
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" style={{maxHeight:"300px",minHeight:"250px",maxWidth:"200px"}} src="img/jaborandi.jpg" alt="" />
                    </div>
                    <div class="text-center py-4">
                        <a class="h6 text-decoration-none text-truncate" href="">Homeopathic Hair Oil</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹123.00</h5><h6 class="text-muted ml-2"><del>₹123.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star-half-alt text-primary mr-1"></small>
                            <small>(88)</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" style={{maxHeight:"300px",minHeight:"250px",maxWidth:"200px"}} src="img/heklalava.jpg" alt="" />
                    </div>
                    <div class="text-center py-4">
                        <a class="h6 text-decoration-none text-truncate" onClick={()=>navigate("/home/toothpaste")}>Homoeopathic Toothpaste</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹123.00</h5><h6 class="text-muted ml-2"><del>₹123.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small>(74)</small>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" style={{maxHeight:"300px",minHeight:"250px",maxWidth:"200px"}} src="img/aquiplus.webp" alt="" />
                    </div>
                    <div class="text-center py-4">
                        <a class="h6 text-decoration-none text-truncate" onClick={()=>navigate("/home/cream")}>Homoeopathic Cream</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹123.00</h5><h6 class="text-muted ml-2"><del>₹123.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star-half-alt text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small>(61)</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" style={{maxHeight:"300px",maxWidth:"200px"}} src="img/aquiplusfacewash.jpg" alt="" />
                    </div>
                    <div class="text-center py-4">
                        <a class="h6 text-decoration-none text-truncate" onClick={()=>navigate("/home/facewash")}>Homoeopathic Facewash</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹123.00</h5><h6 class="text-muted ml-2"><del>₹123.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small>(58)</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6 pb-1">
                <div class="product-item bg-light mb-4">
                    <div class="product-img position-relative overflow-hidden text-center">
                        <img class="img-fluid w-100" style={{maxHeight:"310px",maxWidth:"250px"}} src="img/ruckPain.webp" alt="" />
                    </div>
                    <div class="text-center py-4">
                        <a class="h6 text-decoration-none text-truncate" onClick={()=>navigate("/home/pain")}>Pain Killer</a>
                        <div class="d-flex align-items-center justify-content-center mt-2">
                            {/* <h5>₹123.00</h5><h6 class="text-muted ml-2"><del>₹123.00</del></h6> */}
                        </div>
                        <div class="d-flex align-items-center justify-content-center mb-1">
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="fa fa-star text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small class="far fa-star text-primary mr-1"></small>
                            <small>(58)</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default FeaturedProducts